import { ref } from "vue";
import { useNotifications } from "@/shared/composables/useNotifications.composable";
import type { MobilityRegistrationFormData } from "@/app/registration-app/user/mobility-registration/@types/RegistrationFormData";
import { registerMobilityUser } from "@/app/registration-app/user/mobility-registration/services/registerMobilityUser.service";

export const useRegisterMobilityUser = () => {
  const { addErrorSnackbar } = useNotifications();

  const isRegisteringMobilityUser = ref(false);
  const registeringMobilityUserError = ref<string>();
  const caseNumber = ref<string>();

  const onRegisteringMobilityUser = async (
    registrationData: MobilityRegistrationFormData,
  ) => {
    try {
      registeringMobilityUserError.value = undefined;
      isRegisteringMobilityUser.value = true;
      caseNumber.value = await registerMobilityUser({
        salutation: registrationData.salutation,
        firstName: registrationData.firstName,
        lastName: registrationData.lastName,
        email: registrationData.email,
        customerId: registrationData.customerId,
        captcha: registrationData.captcha,
      });
    } catch (error) {
      registeringMobilityUserError.value = error as string;
      addErrorSnackbar(error as string);
    } finally {
      isRegisteringMobilityUser.value = false;
    }
  };

  return {
    caseNumber,
    isRegisteringMobilityUser,
    registeringMobilityUserError,
    onRegisteringMobilityUser,
  };
};
